import { render, staticRenderFns } from "./MerchantCard.vue?vue&type=template&id=7f8085fe&scoped=true"
import script from "./MerchantCard.vue?vue&type=script&lang=js"
export * from "./MerchantCard.vue?vue&type=script&lang=js"
import style0 from "./MerchantCard.vue?vue&type=style&index=0&id=7f8085fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8085fe",
  null
  
)

export default component.exports